<template>
  <div class="app-consent-accept">
    <slot name="txtBefore"></slot>

    <div v-for="channel in channels" :key="channel.adChannelType">
      <slot :name="`txtBeforeChannel${channel.adChannelType}`"></slot>
      <ChannelAccept :channel="channel" @update:select="selectItem(channel, $event)">
        <template #lblChannel><slot :name="`lblChannel${channel.adChannelType}`"></slot></template>
        <template #lblChange><slot :name="`lblChange${channel.adChannelType}`"></slot></template>
      </ChannelAccept>
      <slot :name="`txtAfterChannel${channel.adChannelType}`"></slot>
    </div>
    <slot name="txtBetween"></slot>
    <ConsentTextAccept
      :explicit="consent.explicit"
      :consentText="consent"
      :selected="consent.selected"
      @update:selected="selectConsent($event)"
    >
      <template v-for="slot in possibleChildSlotsFor('AcceptText')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ConsentTextAccept>

    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import ChannelAccept from './ChannelAccept.vue'
import slotProxy from '../../../../mixins/slotProxy'
import ConsentTextAccept from './TextAccept.vue'
import preFilledInput from '../../../../mixins/preFilledInput'
export default {
  name: 'ConsentAccept',
  components: {
    ConsentTextAccept,
    ChannelAccept
  },
  computed: {
    channels: function() {
      const channels = [
        ...(this.consent?.selectedAdChannels || []).map(channel => {
          return { ...channel, selected: true }
        }),
        ...(this.consent?.notSelectedAdChannels || []).map(channel => {
          return { ...channel, selected: false }
        })
      ]
      return channels
        .filter(channel => this.channelTypes.includes(channel.adChannelType))
        .sort((a, b) => this.channelTypes.indexOf(a.adChannelType) - this.channelTypes.indexOf(b.adChannelType))
    }
  },
  methods: {
    selectItem(changeChannel, selected) {
      const active = this.consent.selectedAdChannels || []
      const inactive = this.consent.notSelectedAdChannels || []
      delete changeChannel.selected
      if (selected) {
        this.consent = Object.assign({
          ...this.consent,
          notSelectedAdChannels: inactive.filter(channel => channel.adChannelType !== changeChannel.adChannelType),
          selectedAdChannels: [...active, changeChannel]
        })
      } else {
        this.consent = Object.assign({
          ...this.consent,
          notSelectedAdChannels: [...inactive, changeChannel],
          selectedAdChannels: active.filter(channel => channel.adChannelType !== changeChannel.adChannelType)
        })
      }
    },
    selectConsent(value) {
      this.consent = {
        ...this.consent,
        selected: value
      }
    }
  },
  mixins: [preFilledInput('consent', 'givenConsent', 'changedConsent'), slotProxy()],
  props: {
    givenConsent: {
      type: Object
    },
    channelTypes: {
      type: Array,
      default: () => []
    }
  }
}
</script>
